import { render, staticRenderFns } from "./TabPaymentList.vue?vue&type=template&id=36f2eea8&scoped=true"
import script from "./TabPaymentList.vue?vue&type=script&lang=js"
export * from "./TabPaymentList.vue?vue&type=script&lang=js"
import style0 from "./TabPaymentList.vue?vue&type=style&index=0&id=36f2eea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2eea8",
  null
  
)

export default component.exports